export default "__VITE_ASSET__CYlxH5n5__"